import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-consignment',
  templateUrl: './consignment.component.html',
  styleUrls: ['./consignment.component.css','../app.component.css']
})
export class ConsignmentComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/consignment/consignment.component.ts